import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function WithOvarianCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Individual with non-mucinous epithlial ovarian cancer at any age</>),
            (<>Individual with epithelial ovarian cancer and &ge; 1 first degree relative with epithelial ovarian cancer</>),
            (<>Individual with epithelial ovarian cancer and &ge; 1 second degree relative with epithelial ovarian cancer (intervening relative is male, or female who has had risk of reducing ovarian surgery, or a female deceased &lt;60)</>),
            (<>Individual with epithelial ovarian cancer and &ge; 2 second / third degree relatives with epithelial ovarian cancer</>)
        ],
        properties: {
            color: 'purple'
        }
    });
}

export default WithOvarianCancer;
